
export const transformMwlData = (mwlData) => {
    const mwl_data_objects = Object.values(mwlData);
    const mwl_data_objects_filtered = mwl_data_objects.filter(item => item.data);

    return mwl_data_objects_filtered.map(item => ({
        id: item.data.id,
        src: item.file,
        msrc: item.file,
        width: item.dimension.width,
        height: item.dimension.height,
        thumbCropped: true,

        meta: {
            title: item.data.title,
            caption: item.data.caption,
            description: item.data.description,
            keywords: item.data.keywords,
            copyright: item.data.copyright,
            date: item.data.date,
            download: item.download_link,
        },

        exif: {
            camera: item.data.camera,
            focal_length: item.data.focal_length,
            shutter_speed: item.data.shutter_speed,
            aperture: item.data.aperture,
            iso: item.data.iso,
            lens: item.data.lens,
            date: item.data.date,
            keywords: item.data.keywords,
            gps: item.data.gps,
        },
    }));
};

export const transformAnimationType = (animationType) => {
    switch (animationType) {
        case 'zoom_in_out':
            return 'zoom';
        case 'fade':
            return 'fade';
        case 'none':
            return 'none';
        default:
            return 'zoom';
    }
};

export const transformExifData = (image, infos_to_display) => {

    const exif = [
      {
        name: 'Camera',
        icon: 'camera',
        value: image?.exif?.camera,
        visible: image?.exif?.camera !== "N/A" && infos_to_display.camera,
      },
      {
        name: 'Lens',
        icon: 'lens',
        value: image?.exif?.lens,
        visible: image?.exif?.lens !== "N/A" && infos_to_display.lens,
      },
      {
        name: 'FocalLength',
        icon: 'eye',
        value: image?.exif?.focal_length,
        visible: image?.exif?.focal_length !== "N/A" && infos_to_display.focal_length,
      },
      {
        name: 'ShutterSpeed',
        icon: 'shutter_speed',
        value: image?.exif?.shutter_speed,
        visible: image?.exif?.shutter_speed !== "N/A" && infos_to_display.shutter_speed,
      },
      {
        name: 'Aperture',
        icon: 'aperture',
        value: image?.exif?.aperture,
        visible: image?.exif?.aperture !== "N/A" && infos_to_display.aperture,
      },
      {
        name: 'Iso',
        icon: 'iso',
        value: image?.exif?.iso,
        visible: image?.exif?.iso !== "N/A" && infos_to_display.iso,
      },
      {
        name: 'Date',
        icon: 'calendar',
        value: image?.exif?.date,
        visible: image?.exif?.date !== "N/A" && image?.exif?.date != 0 && infos_to_display.date,
      },
      {
        name: 'Keywords',
        icon: 'sharing',
        value: image?.exif?.keywords,
        visible: image?.exif?.keywords !== "N/A" && infos_to_display.keywords,
      }
    ];
  
    return exif.filter(item => item.visible);
  
  };

export const preventRightClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    return false;
};

export const initializeMapInContainer = (containerId, imageData) => {
    if (typeof window.mwlInitMap === 'undefined') {
        console.error('window.mwlInitMap is not defined. Please check that you have included the map script in your page.');
        return;
    }

    const gps = imageData.exif.gps;

    if (!gps || gps === 'N/A') {
        console.warn('No GPS data available for this image.');
        return;
    }

    const gpsCoords = gps.split(',');
    const lat = parseFloat(gpsCoords[0]);
    const lng = parseFloat(gpsCoords[1]);

    const image = {
        gps: {
            lat: lat,
            lng: lng,
        },
        src: imageData.src,
        dimensions: {
            width: imageData.width,
            height: imageData.height,
        },
        low_res_src: imageData.msrc,
        exifs: {
            caption: imageData.meta.caption,
        },
        title: imageData.meta.title,
    };

    window.mwlInitMap(containerId, image);
};